import { render, staticRenderFns } from "./ReportsTableBottomActionBar.vue?vue&type=template&id=b4c5135a&"
import script from "./ReportsTableBottomActionBar.vue?vue&type=script&lang=js&"
export * from "./ReportsTableBottomActionBar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports